module.exports = __webpack_public_path__ + "media/images/rank/diamond-914a0eb999c9443c4c728660c6869c82.png";